import {Inject, Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import * as user from "user";

@Injectable()
export class TransferGuardService implements CanActivate {
	// User data
	userIsOem: boolean;

	constructor(public router: Router,
				@Inject("isOemUser") userIsOem: boolean) {
		this.userIsOem = userIsOem;
	}

	canActivate(): boolean {
		if (!user.signedIn) {
			this.router.navigate(["overview"]);
			return false;
		}
		if (!this.userIsOem && !user.isDealer && !user.isOemDistributor) {
			this.router.navigate(["list"]);
			return false;
		}
		return true;
	}
}
